export class SearchUtils {
    public static parseSearchArgument(rawSearchArgument: string): string {
        let searchArgument: string = rawSearchArgument;
        if (!searchArgument) {
            searchArgument = '';
        }
        return searchArgument.trim().toLowerCase();
    }
}